/** Nobody awaits the answer, so nothing to report. Duck-typed: DOMException isn't an `Error` in every engine. */
export function isRequestCancellation(error: unknown): boolean {
    const { name, message } = readErrorShape(error);
    if (name === 'AbortError') {
        return true;
    }
    return CANCELLED_REQUEST_MESSAGES.some((cancelled) => message.includes(cancelled));
}

const CANCELLED_REQUEST_MESSAGES = [
    // Chromium, when `abort()` was called without an argument
    'signal is aborted without reason',
    // Firefox and Safari word the same thing differently
    'The operation was aborted',
    'Fetch is aborted',
];

function readErrorShape(error: unknown): { name: string; message: string } {
    if (typeof error === 'string') {
        return { name: '', message: error };
    }
    if (typeof error !== 'object' || error === null) {
        return { name: '', message: '' };
    }
    const { name, message } = error as { name?: unknown; message?: unknown };
    return {
        name: typeof name === 'string' ? name : '',
        message: typeof message === 'string' ? message : '',
    };
}
